import Reveal from '@/components/base/Reveal';
import SectionTitle from '@/components/base/SectionTitle';
import { reviews, dramaMeta } from '@/mocks/drama';

const topicTags = ['反转铺垫多', '大结局呼应强', '姐姐线好哭', '日常戏烟火气', '适合一口气看完', '单集时长友好'];

export default function ReviewSection() {
  return (
    <section id="reviews" className="bg-secondary-50 py-14 md:py-20">
      <div className="mx-auto px-4 md:px-6 max-w-7xl">
        <Reveal>
          <SectionTitle
            eyebrow="观众热议"
            title="看完的人在聊什么"
            description="以下为观众反馈的整理与归纳，聚焦大家反复提到的看点与感受，方便还没开始看的你判断这部剧合不合口味。"
          />
        </Reveal>

        <Reveal delay={60}>
          <div className="mt-8 flex flex-wrap gap-2">
            {topicTags.map((tag) => (
              <span key={tag} className="rounded-full bg-accent-100 px-4 py-1.5 font-label text-sm text-accent-900">
                # {tag}
              </span>
            ))}
          </div>
        </Reveal>

        <div className="mt-8 grid gap-4 md:gap-5 grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
          {reviews.map((item, index) => (
            <Reveal key={item.id} delay={(index % 3) * 60}>
              <article className="h-full rounded-lg border border-secondary-200 bg-background-50 p-5">
                <div className="flex items-center justify-between gap-3">
                  <div className="flex items-center gap-3">
                    <span className="flex h-9 w-9 items-center justify-center rounded-full bg-secondary-500 font-heading text-sm font-bold text-background-50 dark:text-foreground-950">
                      {item.user.slice(0, 1)}
                    </span>
                    <span className="font-label text-sm font-medium text-foreground-900">{item.user}</span>
                  </div>
                  <span className="rounded-full bg-secondary-100 px-2.5 py-0.5 font-label text-xs text-secondary-800">{item.badge}</span>
                </div>
                <p className="mt-4 font-body text-sm leading-relaxed text-foreground-700">{item.text}</p>
                <div className="mt-4 flex items-center gap-1 text-accent-500" aria-hidden="true">
                  <i className="ri-star-fill" />
                  <i className="ri-star-fill" />
                  <i className="ri-star-fill" />
                  <i className="ri-star-fill" />
                  <i className="ri-star-fill" />
                </div>
              </article>
            </Reveal>
          ))}
        </div>

        <Reveal delay={120}>
          <p className="mt-8 font-body text-xs md:text-sm text-foreground-600 leading-relaxed">
            说明：以上为基于观众讨论内容的归纳整理，用于辅助判断剧集风格，具体情节以《{dramaMeta.name}》正式上线版本为准。
          </p>
        </Reveal>
      </div>
    </section>
  );
}